import { Card, Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { AvatarAndBadge } from '../../../../shared/components/AvatarAndBadge';
import { DecisionMakerResponse } from '../../../../shared/components/DecisionMakerResponse';
import { Location } from '../../../../shared/components/Location';
import { Name } from '../../../../shared/components/Name';
import { ResponseBadge } from '../../../../shared/components/ResponseBadge';
import { Signers } from '../../../../shared/components/Signers';
import type { NormalizedDecisionMaker } from '../../../../shared/types';

export const DecisionMakerCardDesktop: React.FC<{
	dm: NormalizedDecisionMaker;
}> = ({
	dm: {
		displayName,
		id,
		location,
		title,
		photoUrl,
		publiclyVisible,
		isFormer,
		constituentCount,
		constituentCountLocalized,
		slug,
		response,
		type,
	},
}) => {
	const heading = title ? `${displayName},` : displayName;

	return (
		<Card className="hidden bg-white p-6 shadow-md lg:block">
			<div className={cn('flex items-center gap-4', response && 'items-start')}>
				<div>
					<AvatarAndBadge displayName={displayName} photoUrl={photoUrl} showDMIcon={type === 'POLITICIAN'} />
				</div>

				<div
					className={cn('w-full', {
						'-mt-6': type === 'POLITICIAN' && !response,
					})}
				>
					<div className="flex w-full flex-col xl:flex-row">
						<div className="mr-1 flex w-full">
							<div className="flex flex-wrap">
								<div className="mr-[6px]">
									<Name displayName={heading} id={id} publiclyVisible={publiclyVisible} slug={slug} />
								</div>
								{title && (
									<Text variant="body" size="large">
										{title}
									</Text>
								)}
							</div>

							<div className="ml-auto shrink-0">
								<ResponseBadge response={response} />
							</div>
						</div>
					</div>

					{(location || constituentCount > 0) && (
						<div className="mt-1 flex min-h-5">
							{location && <Location location={location} />}
							{constituentCount > 0 && (
								<Signers
									constituentCount={constituentCount}
									constituentCountLocalized={constituentCountLocalized}
									isFormer={isFormer}
								/>
							)}
						</div>
					)}

					{response && (
						<div className="mt-4">
							<DecisionMakerResponse response={response} />
						</div>
					)}
				</div>
			</div>
		</Card>
	);
};
